import { useMutation, useQuery } from '@apollo/client'
import { ModalConfirm, Select, useMessage } from '@faceup/ui-base'
import { useEffect, useState } from 'react'
import { graphql } from '../__generated__'

type LinkCompanyToPartnerModalProps = {
  motherId: string
  partnerId?: string
  visible: boolean
  setIsLoading: (loading: boolean) => void
  hide: () => void
}

const query = {
  LinkCompanyToPartnerModalPartnersQuery: graphql(`
    query LinkCompanyToPartnerModalPartnersQuery {
      partners(page: 0, rowsPerPage: 500, verificationStatus: [Approved]) {
        totalCount
        items {
          id
          name
        }
      }
    }
  `),
}

const mutations = {
  LinkCompanyToPartner: graphql(`
    mutation linkCompanyToPartnerMutation($input: LinkCompanyToPartnerInput!) {
      linkCompanyToPartner(input: $input) {
        success
      }
    }
  `),
}

export const LinkCompanyToPartnerModal = ({
  setIsLoading,
  visible,
  hide,
  motherId,
  partnerId,
}: LinkCompanyToPartnerModalProps) => {
  const [selectedPartnerId, setSelectedPartnerId] = useState<string>()
  const message = useMessage()

  const { data, loading } = useQuery(query.LinkCompanyToPartnerModalPartnersQuery, {
    skip: !visible,
  })

  const [linkCompanyToPartner, { loading: linkingToPartner }] = useMutation(
    mutations.LinkCompanyToPartner,
    {
      refetchQueries: ['InstitutionQuery'],
      onCompleted: () => {
        message.success('Company linked')
      },
    }
  )

  useEffect(() => {
    setIsLoading(linkingToPartner)
  }, [linkingToPartner, setIsLoading])

  const partners = data?.partners?.items ?? []

  const onOk = async () => {
    if (selectedPartnerId) {
      await linkCompanyToPartner({
        variables: {
          input: {
            partnerId: selectedPartnerId,
            motherId,
          },
        },
      })
    }
    hide()
  }

  return (
    <ModalConfirm
      open={visible}
      onCancel={hide}
      onConfirm={onOk}
      confirmState={{
        loading,
      }}
      title='Link company to partner'
    >
      <Select
        loading={loading}
        placeholder='Select partner'
        defaultValue={partnerId}
        value={selectedPartnerId}
        onChange={partnerId => setSelectedPartnerId(partnerId)}
        options={partners.map(({ id, name }) => ({ label: name, value: id }))}
      />
    </ModalConfirm>
  )
}
